/**
 * AppLayout component - main layout wrapper for authenticated pages
 * Based on shadcn/ui dashboard-01 block design with SidebarProvider
 */

import { ReactNode } from 'react'
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import { AppSidebar } from './AppSidebar'
import { SiteHeader } from './SiteHeader'

interface AppLayoutProps {
  children: ReactNode
}

/**
 * AppLayout component that wraps page content with consistent layout
 * Uses SidebarProvider and SidebarInset for modern sidebar layout
 * @param children - Page content to render
 */
export function AppLayout({ children }: AppLayoutProps) {
  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': '16rem',
        } as React.CSSProperties
      }
    >
      <AppSidebar />
      <SidebarInset className="overflow-x-hidden">
        <SiteHeader />
        <div className="flex flex-1 flex-col overflow-x-hidden">
          <main id="main-content" className="flex-1 overflow-y-auto overflow-x-hidden">
            <div className="flex flex-col gap-4 p-4 pt-0 md:gap-6 md:p-6 md:pt-0 w-full max-w-full overflow-x-hidden">
              {children}
            </div>
          </main>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}

